<div [ngClass]="{'col-12 col-xl-6' : !allSettings}">
    <div class="card">
        <div class="card-header">
            <h5 class="card-title">{{"channels" | translate}}</h5>
            <h6 class="card-subtitle text-muted">{{"channelsPermanentDesc" | translate}}</h6>
        </div>
        <div class="card-body p-4">
            <div class="d-flex align-items-center gap-2 mb-3">
                <div class="fw-semibold mb-0">{{"channel" | translate}} 1</div>
                <label class="switch mb-0">
                    <input type="checkbox" [checked]="dataCfgDevice.permanent === 1 || dataCfgDevice.permanent === 3"
                        (change)="changePermanentOutput(1, $event.target.checked)">
                    <span class="slider round"></span>
                </label>
            </div>
            <div class="d-flex align-items-center gap-2 mb-3">
                <div class="fw-semibold mb-0">{{"channel" | translate}} 2</div>
                <label class="switch mb-0">
                    <input type="checkbox" [checked]="dataCfgDevice.permanent === 2 || dataCfgDevice.permanent === 3"
                        (change)="changePermanentOutput(2, $event.target.checked)">
                    <span class="slider round"></span>
                </label>
            </div>

            <div class="form-group row mt-4">
                <div class="col-sm-10 ms-sm-auto">
                    <button type="submit" class="btn btn-primary" (click)="save()" [disabled]="!changesMade">{{"overwrite" | translate}}</button>
                    <button type="button" class="btn btn-light ms-2" (click)="restore()" [disabled]="!changesMade">{{"restore" | translate}}</button>
                </div>
            </div>

            <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="error!=''">
                <div class="alert-message">
                    {{ error }}
                </div>
            </div>
            <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage">
                <div class="alert-message">
                    {{"updatedSuccesfully" | translate}}
                </div>
            </div>
        </div>
    </div>
</div>
